import { ContainerComponent, wrap } from 'AppReact';
import { SecondaryTextXs } from 'atoms';
import internalState from './internalState';
import {
  MakeReadyItemCellWrapper, Td, ElementWithPopupWrapper, SpanWrapper, FullWidthHeightJustifyCenter
} from 'wrappers';

export const definition = {
  name: 'TextCell',
  controller: {},
  initialProps: ({ showCheckboxes }) => ({ showCheckboxes }),
  props: internalState,
  elements: [
    {
      wrapper: MakeReadyItemCellWrapper,
      name: 'Selector',
      renderIf: ({ displayConfetti }) => !displayConfetti,
      displayState: ({ }) => ({ background: '#F7F7F7' }),
      elements: [
        {
          wrapper: ElementWithPopupWrapper,
          name: 'HideWrapper',
          displayState: ({ }) => ({ width: '100%', height: '100%' }),
          elements: [
            {
              component: wrap(wrap(SecondaryTextXs, FullWidthHeightJustifyCenter), SpanWrapper),
              name: 'Text',
              displayValue: ({ }) => 'N/A'
            },
          ]
        }
      ]
    },
  ]
}

export default wrap(ContainerComponent(definition), Td)